import { createTheme, TextField } from "@mui/material";
import "@fontsource/roboto";
import "@fontsource/roboto-slab";
import palette from "./palette";
import { styled } from "@mui/material/styles";
const customeTheme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 768,
      lg: 1024,
      xl: 1536,
    },
  },

  palette: palette,
});

export const StyledTextBox = styled(({ className, ...props }) => <TextField {...props} classes={{ popper: className }} />)`
  .MuiTextField-root {
    background-color: #20b2aa;
  }
  .MuiTextField-root .MuiTextField-label {
    background-color: white;
  }
  .MuiTextField-root .MuiTextField-label:shrink {
    background-color: black;
  }
`;

export const drawerWidth = 305

export default customeTheme;
